import React, { Component } from 'react';
import { Form, Message, Segment, Button, Grid, Header, Image } from 'semantic-ui-react';
import FormInput from './form_input.js';

export default class FormElementRegister extends React.Component {
	
	constructor(props) {
		
		super(props);
		
		this.state = {
			error: {
				username: false,
				password1: false,
				password2: false,
				email: false
			},
			value: {
				username: "",
				password1: "",
				password2: "",
				email: ""
			},
			errorText: {
				usernamePassword: false,
				differentPasswords: false,
				emptyField: false,
				weakPassword: false
			}
		};
		
		this.handleSubmit = this.handleSubmit.bind(this);
		this.typeError = this.typeError.bind(this);
		this.handleValue = this.handleValue.bind(this);
	}
	
	handleSubmit(e) {
		
		var { error, value, errorText } = this.state;
		
		const { loading, loadingState } = this.props;
		
		if (loading) return true;
		
		const keys = Object.keys(value);
		
		for (var i = 0; i < keys.length; i++)
		{
			if (value[keys[i]] == "")
			{
				errorText.emptyField = true;
				
				break;
			}
			else if (i == keys.length - 1)
			{
				errorText.emptyField = false;
			}
		}
		
		if (value.password1.trim().length < 8)
		{
			errorText.weakPassword = true;
		}
		
		if (value.password1.trim() != value.password2.trim())
		{
			errorText.differentPasswords = true;
		}
		else
		{
			errorText.differentPasswords = false;
		}
		
		this.setState({ errorText });
		
		if (error.username || error.password1 || error.password2 || error.email)
		{
			loadingState(false);
			
			return false;
		}
		
		loadingState(true);
		
		if (!document.getElementById("loading-screen"))
		{
			setTimeout(() => {this.props.callbackRequest({})}, 500);
		}
		else
		{
			registerRequest = new ActionRequest(
				"action_valuation_user_register", {
					username: value.username, password: value.password1, email: value.email
				}
			);
			
			registerRequest.Success = this.props.callbackRequest;
			
			registerRequest.Fail = this.props.callbackRequest;
			
			registerRequest.Trigger();
		}
	}
	
	typeError(e, errorState) {
		
		var { error, errorText } = this.state;
		
		error[e.target.name] = errorState;
		
		if (errorState)
		{
			errorText.usernamePassword = true;
		}
		else
		{
			const keys = Object.keys(error);
			
			for (var i = 0; i < keys.length; i++)
			{
				if (error[keys[i]])
				{
					break;
				}
				else if (i == keys.length - 1)
				{
					errorText.usernamePassword = false;
				}
			}
		}
		
		this.setState({ error, errorText });
	}
	
	handleValue(e, valueState) {
		
		var value = this.state.value;
		
		value[e.target.name] = valueState;
		
		this.setState({ value });
	}
	
	render() {
		
		const { error, errorText } = this.state;
		
		const { handleSubmit, typeError, handleValue } = this;
		
		const { loading, linkLogo, notice, changeForm, notverified } = this.props;
		
		return (
			<Grid.Column style={{ maxWidth: 500 }}>
				<Header as="h2" style={{ color: "white" }} textAlign="center">
					<Image style={{ marginTop: "-4px" }} src={linkLogo} /> Sign up to our services
				</Header>
				<Form size="large">
					<Segment>
						<FormInput
							error={error.username}
							tabIndex={1}
							icon="user"
							name="username"
							placeholder="Username"
							handleValue={handleValue}
							errorRegexp={/[^a-zA-Z0-9.\-_@]+/g}
							typeError={typeError}
						/>
						<FormInput
							error={error.password1}
							tabIndex={2}
							icon="lock"
							name="password1"
							type="password"
							placeholder="Password"
							handleValue={handleValue}
							typeError={typeError}
						/>
						<FormInput
							error={error.password2}
							tabIndex={3}
							icon="lock"
							name="password2"
							type="password"
							placeholder="Re-Type Password"
							handleValue={handleValue}
							typeError={typeError}
						/>
						<FormInput
							error={error.email}
							tabIndex={4}
							icon="mail"
							name="email"
							placeholder="Email Address"
							handleValue={handleValue}
							errorRegexp={/[^a-zA-Z0-9.\-_@]+/g}
							typeError={typeError}
						/>
						<Button
							fluid
							onClick={handleSubmit}
							loading={loading}
							color="blue"
							size="large"
						>
							Sign up
						</Button>
					</Segment>
				</Form>
				<Message>
					<a href="javascript:void(0)" onClick={changeForm} action="login" className="ignore">
						Log in
					</a>
				</Message>
				{/*<Message>
					<a href='/action/password_reset' className="ignore">
						Forgot your password?
					</a>
				</Message>*/}
				{
					notverified &&
					<Message warning style={{ textAlign: "left" }}>
						<Message.Header>{text.notverified}</Message.Header>
						<a href="/action/resend_verification_email" className="ignore">
							You did not receive a verification e-mail?
						</a>
					</Message>
				}
				{
					errorText.usernamePassword &&
					<Message negative style={{ textAlign: "left" }}>
						<Message.Header>Incorrect username or password.</Message.Header>
						<p>The username, e-mail or password that you provided is not correct.</p>
					</Message>
				}
				{
					errorText.emptyField &&
					<Message negative style={{ textAlign: "left" }}>
						<Message.Header>All fields must be filled before submit</Message.Header>
						<p>Please fill all the form fields before submitting.</p>
					</Message>
				}
				{
					errorText.differentPasswords &&
					<Message negative style={{ textAlign: "left" }}>
						<Message.Header>Passwords does not match.</Message.Header>
						<p>Please make sure the passwords are identical.</p>
					</Message>
				}
				{
					errorText.weakPassword &&
					<Message negative style={{ textAlign: "left" }}>
						<Message.Header>Password is too weak.</Message.Header>
						<p>Please make sure the password length is greater than 7 characters.</p>
					</Message>
				}
				{
					notice &&
					<Message warning style={{ textAlign: "left" }}>
						<p>{notice}</p>
					</Message>
				}
			</Grid.Column>
		);
	}
}